<template>
  <v-container class="pa-0">
    <b>Trusted by hundreds of labs</b>
    <div class="carousel-wrapper">
      <div class="carousel-track">
        <div class="carousel-slide">
          <a
            v-for="(partner, index) in carouselPartners"
            :href="partner.link"
            :key="`${partner.link}-${index}`"
            target="_blank"
            class="partner-link"
          >
            <v-img :src="partner.image" class="partner-image" contain></v-img>
          </a>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import AdventImg from "@bugseq-site/www/src/assets/img/partners/advent.png";
import CambridgeImg from "@bugseq-site/www/src/assets/img/partners/cambridge.png";
import OxfordImg from "@bugseq-site/www/src/assets/img/partners/oxford.png";
import ColumbiaImg from "@bugseq-site/www/src/assets/img/partners/columbia.png";
import HopkinsImg from "@bugseq-site/www/src/assets/img/partners/hopkins.png";
import JessaImg from "@bugseq-site/www/src/assets/img/partners/jessa.png";
import MskccImg from "@bugseq-site/www/src/assets/img/partners/mskcc.png";
import PhacImg from "@bugseq-site/www/src/assets/img/partners/phac.png";
import SinaiHealthImg from "@bugseq-site/www/src/assets/img/partners/sinai_health.png";
import TrilliumImg from "@bugseq-site/www/src/assets/img/partners/trillium.png";
import VghImg from "@bugseq-site/www/src/assets/img/partners/vgh.png";
import CdcImg from "@bugseq-site/www/src/assets/img/partners/cdc.png";
import CornellImg from "@bugseq-site/www/src/assets/img/partners/cornell.png";
import IowaImg from "@bugseq-site/www/src/assets/img/partners/iowa.png";
import MayoImg from "@bugseq-site/www/src/assets/img/partners/mayo.png";
import NhsImg from "@bugseq-site/www/src/assets/img/partners/nhs.png";
import PhcImg from "@bugseq-site/www/src/assets/img/partners/phc.png";
import VaImg from "@bugseq-site/www/src/assets/img/partners/va.png";
import VumcImg from "@bugseq-site/www/src/assets/img/partners/vumc.png";

@Component
export default class Partners extends Vue {
  partners = [
    {image: CdcImg, link: "https://www.cdc.gov/index.html"},
    {image: AdventImg, link: "https://www.adventhealth.com/"},
    {image: ColumbiaImg, link: "https://www.cuimc.columbia.edu/"},
    {image: HopkinsImg, link: "https://www.hopkinsmedicine.org/"},
    {image: NhsImg, link: "https://www.nhs.uk/"},
    {image: MskccImg, link: "https://www.mskcc.org/"},
    {image: JessaImg, link: "https://www.jessazh.be/"},
    {image: CambridgeImg, link: "https://www.zoo.cam.ac.uk/"},
    {image: PhacImg, link: "https://www.canada.ca/en/public-health.html"},
    {image: SinaiHealthImg, link: "https://www.sinaihealth.ca/"},
    {image: OxfordImg, link: "https://www.biology.ox.ac.uk/home"},
    {image: TrilliumImg, link: "https://www.thp.ca/Pages/Home.aspx"},
    {image: VghImg, link: "https://www.vch.ca/en/location/vancouver-general-hospital"},
    {image: PhcImg, link: "https://www.providence.org/"},
    {image: VaImg, link: "https://www.va.gov/health-care/"},
    {image: VumcImg, link: "https://www.vumc.org/main/home"},
    {image: IowaImg, link: "https://shl.uiowa.edu/"},
    {image: MayoImg, link: "https://www.mayoclinic.org/"},
    {image: CornellImg, link: "https://www.nyp.org/locations/newyork-presbyterian-weill-cornell-medical-center"},
  ];

  get carouselPartners() {
    // we duplicate it so it is an infinite loop.
    // i.e. once it rolls through the first iteration, we need continuity
    // starting from the beginning until it reaches its initial state and
    // "resets".
    // we reverse because it goes left-to-right, so the bottom logos
    // are initially visible and we immediately roll around to the top of the list.
    return [...this.partners, ...this.partners].reverse()
  }
};
</script>

<style scoped>
.carousel-wrapper {
  overflow: hidden;
  width: 100%;
  position: relative;
  mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
}

.carousel-track {
  display: flex;
  width: max-content;
  animation: scroll 40s linear infinite reverse;
}

.carousel-track:hover {
  animation-play-state: paused;
}

.carousel-slide {
  display: flex;
  flex-shrink: 0;
}

.partner-link {
  display: flex;
  align-items: center;
}

.partner-image {
  width: 150px;
  margin: 30px;
  flex-shrink: 0;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
